import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DsButtonVariants, DsModalService } from '@levelaccess/design-system';

@Component({
  selector: 'app-confirm-deletion-dialog',
  standalone: false,
  template: `
    <ds-modal [modal]="modal" [title]="'delete_finding_title' | translate" [maxWidthPercentage]="60">
      <p>{{ translation_key | translate }}</p>
      <div class="row">
        <div class="col-12 col-md-auto">
          <button ds-button [variant]="DsButtonVariants.primary" (click)="confirmed.emit(); modalService.closeAllModals()">
            {{ 'delete_finding' | translate }}
          </button>
        </div>
        <div class="col-12 col-md-auto mt-3 mt-md-0">
          <button ds-button [variant]="DsButtonVariants.secondary" (click)="modalService.closeAllModals()">
            {{ 'label_cancel' | translate }}
          </button>
        </div>
      </div>
    </ds-modal>
  `,
})
export class DeleteConfirmDialogComponent {
  protected readonly DsButtonVariants: typeof DsButtonVariants = DsButtonVariants;

  @Input()
  public translation_key: string = 'cannot_be_undone';

  @Output()
  public confirmed: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    public modal: NgbActiveModal,
    public modalService: DsModalService,
  ) {}
}
